import type { PolicySettings } from '@kirin/api-client/contracts/policies';

/**
 * Builds a full policy-settings payload from current server state plus updates.
 * Required for account-scope saves: user settings API replaces the entire row.
 * Organization versioned updates merge partial payloads, but this helper is safe
 * for both scopes.
 */
export function buildPolicySettingsPayload(
  settingsData: PolicySettings | undefined,
  updates: Record<string, unknown>
): Record<string, unknown> {
  const payload: Record<string, unknown> = {};
  for (const setting of settingsData?.settings ?? []) {
    payload[setting.key] = setting.value;
  }
  return { ...payload, ...updates };
}
